import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description CCDelivery icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { CCDelivery } from '@sravni/design-system-icons'
 *
 * <CCDelivery />
 * ```
 */
var CCDelivery = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "CCDelivery", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M3.236 7.5h15M8.654 10.833H6.57M9.903 15.833H3.236M8.236 14.167l1.667 1.666L8.236 17.5M3.236 12.5V6.667a2.5 2.5 0 0 1 2.5-2.5h10a2.5 2.5 0 0 1 2.5 2.5v6.666a2.5 2.5 0 0 1-2.5 2.5h-2.5", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { CCDelivery };
//# sourceMappingURL=CCDelivery.js.map
